Ext.define('SA.AcsTable.Model', {
    alias: 'view.acsTable',
    extend: 'SA.data.View',

    mixins: {
        locations: 'SA.data.mixin.ManyLocations'
    },

    statics: {
        create({project, data, locationItems}) {
            return SA.AcsTable.ModelFactory.createModel({project, data, locationItems});
        },

        getDefaultTableId() {
            return 'B01001';
        },

        instantiate({id, project, data, saved}) {
            return SA.AcsTable.ModelFactory.instantiateModel({id, project, data, saved});
        }
    },

    addLocationImpl(location) {
        this.project.addLocation(location);

        this.mixins.locations.addLocationImpl.call(this, location);
    },

    getReferencedAttributes() {
        return this.requestedAttributeIds.getIds();
    },

    getSortedEditions() {
        var censusReleaseYear = this.getCensusReleaseYear(),
            editions = SA.data.Vendors.getACSModel().getEditionsForCensusReleaseYear(censusReleaseYear).slice();

        editions.sort((a, b) => b - a);

        return editions;
    },

    getState() {
        return this.state;
    },

    isSavable() {
        return false; 
    },

    isViewable() {
        return this.state.isViewable();
    },

    resolveState() {
        var viewName = this.getName(),
            {edition, tableId} = this.data,
            censusReleaseYear = this.getCensusReleaseYear(),
            selectedLocations = this.getLocations().map(id => SA.model.LocationFactory.create(id)),
            projectLocations = this.getProjectLocations().map(id => SA.model.LocationFactory.create(id)),
            selectableLocations = projectLocations.filter(location => this.supportsLocation(location.getStringId())),
            unselectableLocations = projectLocations.filter(location => !this.supportsLocation(location.getStringId()));

        this.state = new SA.AcsTable.ModelState({
            viewName,
            edition,
            tableId,
            censusReleaseYear,
            selectedLocations,
            selectableLocations,
            unselectableLocations
        });

        this.fireEvent('stateResolved');
    },

    setEdition(edition) {
        this.data.edition = edition;
        this.resolveState();
    },

    setTableId(tableId) {
        this.data.tableId = tableId;
        this.resolveState();
    },

    supportsAttribute(attributeId) {
        var attribute = SA.data.AttributesCache.getModel(attributeId),
            isAcs = attribute.hasDatasetSeries(SA.DatasetIds.ACS),
            matchesCensusRelease = attribute.hasCensusReleaseYear(this.getCensusReleaseYear());

        return isAcs && matchesCensusRelease;
    },

    supportsDatasetSeries(datasetSeries) {
        return SA.data.Vendors.getDatasetModel(datasetSeries).isACS();
    }
});